import { MAPPING_HYPERVISOR_ID_FIELD, MAPPING_HYPERVISORNAME_FIELD } from '../InfrastructureConstants';
import { InfrastructureLink } from '../InfrastructureLinkUtils';

/**
 * Displays a drill-in link to the hypervisor detail page
 * Shows invalid value placeholder if hypervisor data is missing
 */
const HypervisorLink = () => {
    return <InfrastructureLink nameField={MAPPING_HYPERVISORNAME_FIELD} idField={MAPPING_HYPERVISOR_ID_FIELD} />;
};

export default HypervisorLink;
